export enum BillingPersonType {
  NATURAL_PERSON = 'NATURAL_PERSON',
  JURIDICAL_PERSON = 'JURIDICAL_PERSON'
}
